import { appTenantState } from '@stores/bootstrap-stores/tenant';
import { Module } from '@vincerosoft/assessfluence-types';
import { getModuleRegistry } from '../constants/modules';

export function getModuleDef(id: Module) {
  const MODULE_REGISTRY = getModuleRegistry();
  const appFeatureModules = appTenantState.getState().appSettings?.modules;
  const defaultLabel = MODULE_REGISTRY[id]?.label;

  if (!appFeatureModules) {
    return defaultLabel;
  }

  const module = appFeatureModules.find((m) => m?.id === id);
  return module?.name || defaultLabel;
}
